import {useSelector as _useSelector, TypedUseSelectorHook} from 'react-redux'
import {State} from 'types/state'

export const useSelector: TypedUseSelectorHook<State> = _useSelector
